import { render, staticRenderFns } from "./DrugEvidence.vue?vue&type=template&id=7ead4a35&scoped=true&"
import script from "./DrugEvidence.vue?vue&type=script&lang=js&"
export * from "./DrugEvidence.vue?vue&type=script&lang=js&"
import style0 from "./DrugEvidence.vue?vue&type=style&index=0&id=7ead4a35&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ead4a35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
